module.exports = __webpack_public_path__ + "static/media/country_kz.9f6756ba.webp";